import React from 'react'

import PropTypes from 'prop-types'

import './highlight.css'

const Highlight = (props) => {
  return (
    <div className="highlight-highlight">
      <span className="highlight-text">{props.Title}</span>
      <span className="highlight-text1">{props.Description}</span>
    </div>
  )
}

Highlight.defaultProps = {
  Description:
    'We Hobby Connect, only takes necessary information to give user a welcoming environment.',
  Title: 'Informations are stored in Firebase Securely',
}

Highlight.propTypes = {
  Description: PropTypes.string,
  Title: PropTypes.string,
}

export default Highlight
